


































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";
import DateFormatter from "../../../shared/DateFormatter";
import Loading from "../../general/Loading.vue";
import TextView from "../../controls/TextView.vue";

import RentalProductDetails from "./RentalProductDetails.vue";

import { SettingsPublicJson } from "../../../shared/SettingsJson";
import RentalBookingInfoJson from "../../../shared/RentalBookingInfoJson";
import ClientJson from "../../../shared/ClientJson";
import { RentalItemInfoJson } from "../../../shared/RentalItemJson";
import RentalBookingJson from "../../../shared/RentalBookingJson";
import RentalConditionJson from "../../../shared/RentalConditionJson";
import CategoryTypeJson from "../../../shared/CategoryTypeJson";

import TableView, { TableViewColumnDefinitions } from "../../controls/TableView.vue";

import GeneralInfos from "../../custom/GeneralInfos";
import CustomContent from "../../custom/RentalRegistration";

export default Vue.extend({
  name: "RentalAllProducts",
  components: {
    Loading,
    TextView,
    RentalProductDetails,
    TableView,
  },
  props: {
    appFrameClickedButton: Object,
    settings: Object as PropType<SettingsPublicJson | null>,
    rentalBookingInfo: Object as PropType<RentalBookingInfoJson | null>,
    clientData: Object as PropType<ClientJson>,
    clientPassword: String,
    rentalCart: Array as PropType<RentalBookingJson[]>,
    isForYouth: Boolean,
    restrictToTypeId: Number as PropType<number | null>,
  },
  data() {
    return {
      RestClient: RestClient,
      DateFormatter: DateFormatter,
      GeneralInfos: GeneralInfos,
      CustomContent: CustomContent,
      productsView: "grid" as "list" | "grid",
      useFilters: false as boolean,
      selectedProductId: null as number | null,
      allProducts: null as RentalItemInfoJson[] | null,
      showDetails: false,
      detailsMode: "read",
      filterCategory: null as string | null,
      searchString: "",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", {
      overview: true,
      account: true,
      cart: true,
    });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        //this.reloadData()
      }
    },

    openDetails(item: any | null) {
      if (item != null) {
        this.selectedProductId = item.ID;
      } else {
        this.selectedProductId = null;
      }

      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllProducts();
    },

    /* async loadAllProducts() {
      this.allProducts = null;
      this.selectedProductId = null;

      if (this.RestClient != null) {
        try {
          this.allProducts = await this.RestClient.getRentalItemsInfo();
        } catch (e) {
          alert(e.message);
        }
      }
    }, */

    async loadAllProducts() {
      this.allProducts = null;
      this.selectedProductId = null;

      if (this.RestClient != null) {
        try {
          if (this.clientData && this.clientData.username) {
            this.allProducts = await this.RestClient.getRentalItemsInfoClient(
              this.clientData.username,
              this.clientPassword
            );
          } else {
            this.allProducts = await this.RestClient.getRentalItemsInfo();
          }

          this.filterAllProductsByRestrictToTypeId();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadAllProducts();
    },

    filterAllProductsByRestrictToTypeId() {
      if (this.allProducts) {
        this.allProducts = this.allProducts.filter((i: RentalItemInfoJson) => {
          if (i.restrictToTypes == null) return true;
          if (this.restrictToTypeId && i.restrictToTypes.find((t) => t.ID == this.restrictToTypeId)) return true;
        });
      }
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    removeUseFilters() {
      this.useFilters = false;

      /* this.filterType = null
         this.filterState = null
         this.filterRenew = null */
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetails") {
        this.openDetails(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item);
    },

    getRentalConditionsFilteredByTypes(item: RentalItemInfoJson): RentalConditionJson[] {
      return item.rentalConditions.filter((rc: RentalConditionJson) => {
        if (rc.restrictToTypes == null) {
          return true;
        } else if (this.restrictToTypeId) {
          if (rc.restrictToTypes.find((t) => t.ID == this.restrictToTypeId)) return true;
        } else {
          if (this.clientData != null && this.clientData.types != null) {
            return this.clientData.types && this.clientData.types.length > 0
              ? rc.restrictToTypes.some((i: CategoryTypeJson) =>
                  this.clientData.types!.map((t: CategoryTypeJson) => t.ID).includes(i.ID)
                )
              : false;
          } else {
            return false;
          }
        }
      });
    },

    getCheapestRentalCondition(item: RentalItemInfoJson) {
      let rentalConditions: RentalConditionJson[] = this.getRentalConditionsFilteredByTypes(item);

      rentalConditions = rentalConditions.filter((i: RentalConditionJson) => i.isOnRequestOnly == false);

      if (rentalConditions.length > 0) {
        let cheapest = rentalConditions.reduce((acc: RentalConditionJson, i: RentalConditionJson) =>
          acc.price < i.price ? acc : i
        );

        return cheapest;
      }

      return undefined;
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    restrictToTypeId() {
      this.loadAllProducts();
    },

    clientData: function () {
      this.reloadData();
    },
  },
  computed: {
    allCategories() {
      let categories: string[] = [];

      if (this.allProducts != null) {
        categories = this.allProducts.map((i) => i.category);
      }

      return [...new Set(categories)];
    },

    productColumns(): TableViewColumnDefinitions<RentalItemInfoJson>[] {
      let vue = this;

      return [
        {
          th: "",
          td: (i) => "Vorschaubild",
          image: (i) => vue.RestClient.getRentalItemThumbnailUrl(i.ID!),
        },
        {
          th: "Bezeichnung",
          td: (i) => i.name,
        },
        {
          th: "Kategorie",
          td: (i) => i.category,
        },
        {
          th: "Stückzahl",
          td: (i) => i.amount,
        },
        {
          th: "Preis",
          td: (i) => {
            let cheapestCondition = vue.getCheapestRentalCondition(i);
            if (cheapestCondition !== undefined) {
              return "ab € " + vue.getFormatPrice(cheapestCondition.price);
            } else {
              return "auf Anfrage";
            }
          },
        },
        {
          th: "",
          td: (i) => "Details ansehen",
          style: (i) => "text-align:right",
          button: "openDetails",
        },
      ] as TableViewColumnDefinitions<RentalItemInfoJson>[];
    },

    filteredAllProducts(): RentalItemInfoJson[] | undefined {
      if (this.allProducts != null) {
        var products: RentalItemInfoJson[] = this.allProducts as RentalItemInfoJson[];

        //selected
        let selectedProductIds = this.rentalCart.map((i: RentalBookingJson) => i.rentalItem?.ID);
        products = products.filter((i) => !selectedProductIds.includes(i.ID));

        //categories
        if (this.filterCategory != null) {
          products = products.filter((i) => i.category == this.filterCategory);
        }

        //search
        var tokens = this.searchString
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        for (var token of tokens) {
          products = products.filter(
            (i) => i.name.toLowerCase().includes(token) || i.category.toLowerCase().includes(token)
          );
        }

        return products;
      }
    },
  },
});
